import { render, staticRenderFns } from "./SmbTextArea.vue?vue&type=template&id=87923c6a&scoped=true&"
import script from "./SmbTextArea.vue?vue&type=script&lang=ts&"
export * from "./SmbTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./SmbTextArea.scss?vue&type=style&index=0&id=87923c6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87923c6a",
  null
  
)

export default component.exports